import { z } from '@harvestiq/zod';

export const submitAipPdfReqSchema = z.object({
  coverageId: z.string().uuid(),
});
export type SubmitAipPdfReq = z.infer<typeof submitAipPdfReqSchema>;
